'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateRangeValidator;
var _stringFormat = require('string-format');
var _stringFormat2 = _interopRequireDefault(_stringFormat);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function generateRangeValidator(min, max, message) {
  var minValue = min == null ? -Infinity : min;
  var maxValue = max == null ? Infinity : max;
  return function (value) {
    return minValue <= value && value <= maxValue ? undefined : (0, _stringFormat2.default)(message, {
      min: minValue,
      max: maxValue
    });
  };
}